import { render } from "./Inquiry_Responses.vue?vue&type=template&id=463a8f26"
import script from "./Inquiry_Responses.vue?vue&type=script&lang=js"
export * from "./Inquiry_Responses.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__